import React, { useState } from 'react'
import ModalFactorFormasDeLiquidacion from './ModalFactorFormasDeLiquidacion';
import ModalListaDeSeleccionHonorariosFormasLiquidacion from './ModalListaDeSeleccionHonorariosFormasLiquidacion';
import { postInsertHonorarioFormasLiquidacion } from '../../../services/Contratacion';
import ModalInsertarHonorarioFormasLiquidacion from './ModalInsertarHonorarioFormasLiquidacion';

const ModalAgregarUnaFormaDeLiquidacionEnUpdate = ({setagregarFormas,setactulizarData,item}) => {
    const [isCheckedLiqui, setIsCheckedLiqui] = useState(false); 
    const [loading,setloading]=useState(false)
    const [isCheckedBase, setIsCheckedBase] = useState(false);
    const [seleccionarHonorario, setseleccionarHonorario]=useState(false)
    const [errorSeleccionarHonorario, seterrorSeleccionarHonorario]=useState('Seleccionar un Honorario')
    const [errorSeleccionarFactor, seterrorSeleccionarFactor]=useState('')
    const [errorSeleccionarValor, seterrorSeleccionarValor]=useState('Seleccionar un valor')
    const [modalOnFactor,setmodalOnFactor]=useState(false)
    const [isInputValorHonorarioRango, setisInputValorHonorarioRango]=useState(true)
    const [mensajeHonorarioInsert, setmensajeHonorarioInsert]=useState('')
    const [modalOnMensajeHonorarios, setmodalOnMensajeHonorarios]=useState(false)
    const [dataValorHonorario, setdataValorHonorario]=useState('')
    const [dataHonorarios,setdataHonorarios]=useState({
        HnrCod:'',
        HnrDsc:''
    })
    const [dataFactor, setdataFactor]=useState({
        FctoCod:'',
        FctoDsc:''
    })
    const [isFactor, setisFactor]=useState(false)

    const handleCancelarClick=()=>{
        setagregarFormas(false)
    }

    const handleOnSubmitGuardarFormaLiquidar=(e)=>{
      e.preventDefault()

      const agregarFormaLiquidar={
        ForLiqCod: item,
        HnrCod: e.target.codigoHonorario.value,
        HnrDsc: e.target.descripcionHonorario.value,
        FctoCod: dataFactor.FctoCod,
        FctoDsc: dataFactor.FctoDsc,
        ForLiqcar: e.target.caracteristica.value,
        ForLiqVlHn:dataValorHonorario,
        inputHabilitado: e.target.caracteristica.value === 'F',
        ForCodQx: e.target.codigoqx.value,
        ForInIm: isCheckedLiqui? 'S':'N',
        FOREXCBAS: isCheckedBase? 'S':'N',
        inputRangoValor : e.target.caracteristica.value === 'R'
      }
      
      if(errorSeleccionarHonorario === '' && errorSeleccionarFactor === '' && errorSeleccionarValor === ''){
        
        setloading(true)
        postInsertHonorarioFormasLiquidacion(agregarFormaLiquidar).then((res)=>{
            setloading(false)
            if(!res.data.success){
                setmensajeHonorarioInsert(res.data.message)
                setmodalOnMensajeHonorarios(true)
            }else{
                setagregarFormas(false)
                setactulizarData(agregarFormaLiquidar)
            }
        })
      }
    }

    const handleOnFocusHonorarios=()=>{
        setseleccionarHonorario(true)
    }

    const passDataHonorarios=(codigo,descripcion)=>{
        seterrorSeleccionarHonorario('')
        setseleccionarHonorario(false)
        setdataHonorarios({
            HnrCod:codigo,
            HnrDsc:descripcion
        })
    }

    const handleOnchangeCaracteristica=(e)=>{
      setisInputValorHonorarioRango(e.target.value !== 'R')
      if(e.target.value !== 'R'){
        seterrorSeleccionarValor('Seleccionar un valor')
      }else{
        seterrorSeleccionarValor('')
        setdataValorHonorario('')
      }

        if(e.target.value === 'F'){
            setisFactor(true)
            seterrorSeleccionarFactor('Seleccionar factor')
        }else{
            setisFactor(false)
            seterrorSeleccionarFactor('')
            setdataFactor({
              FctoCod:'',
              FctoDsc:''
            })
        }
    }
    console.log(errorSeleccionarHonorario,'error')
    const passDataFactor=(codigo,descripcion)=>{
        setmodalOnFactor(false)
        seterrorSeleccionarFactor('')
        setdataFactor({
            FctoCod:codigo,
            FctoDsc:descripcion
        })
    }

    const handleOnFocusFactor=()=>{
        setmodalOnFactor(true)
    }

    const handleOnChangeValorHonorario=(e)=>{
      setdataValorHonorario(e.target.value)
        if(e.target.value){
            seterrorSeleccionarValor('')
        }else{
            seterrorSeleccionarValor('Seleccionar un valor')
        }
    }

    const handleOnChangeLiqui = () => {
      setIsCheckedLiqui(!isCheckedLiqui);
    };

    const handleOnChangeBase = () => {
      setIsCheckedBase(!isCheckedBase);
    };
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Crear formas de Liquidación
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
        <form onSubmit={handleOnSubmitGuardarFormaLiquidar}>
          <div className="flex-auto overflow-y-auto relative p-1">
              <div className="flex flex-row py-2  text-left">                
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Codigo Honorario
                  </label>
                  <input
                    defaultValue={dataHonorarios.HnrCod}
                    onFocus={handleOnFocusHonorarios}
                    name='codigoHonorario'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorSeleccionarHonorario}
                  </label>
                </div>
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción Honorario
                  </label>
                  <input
                    defaultValue={dataHonorarios.HnrDsc}
                    disabled={true}
                    name='descripcionHonorario'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                
              </div>
              <div className="flex flex-row py-2  text-left">
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Característica
                  </label>                  
                  <div className="">
                  <select          
                    onChange={handleOnchangeCaracteristica}          
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='caracteristica'
                  >
                    <option value="U">UVR</option>
                    <option value="R">RANGO</option>
                    <option value="V">VALOR FIJO</option>
                    <option value="T">TIEMPO</option>
                    <option value="A">VALOR VARIABLE</option>
                    <option value="F">FACTOR</option>
                  </select>
                </div>
                  
                </div>
                {
                  isInputValorHonorarioRango?
                  <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Vlr Honorarios
                  </label>
                  <input
                    onChange={handleOnChangeValorHonorario}          
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='valorHonorario'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorSeleccionarValor}
                  </label>
                </div>
                :
                
                // <div className="w-1/2  px-1 ">
                //   <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                //     Vlr Honorarios
                //   </label>
                //   <input
                //     //onChange={handleOnChangeValorHonorario}  
                //     disabled={true}        
                //     autoComplete="off"
                //     type="text"
                //     className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                //     id="exampleFormControlInput1"
                //     placeholder=""
                //     name='valorHonorario'
                //   />
                //   <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                //         {errorSeleccionarValor}
                //   </label>
                // </div>
                null
                }
                
              </div>
              {
                isFactor &&
                <div className="flex flex-row py-2  text-left">
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Factor
                  </label>
                  <input   
                    defaultValue={dataFactor.FctoCod} 
                    onFocus={handleOnFocusFactor}                
                    autoComplete="off"
                    type="text"                    
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='factor'
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorSeleccionarFactor}
                  </label>
                  
                </div>
                <div className="w-1/2  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Factor Descripción
                  </label>
                  <input         
                    defaultValue={dataFactor.FctoDsc}         
                    autoComplete="off"
                    type="text"
                    disabled={true}                    
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='factorDescripcion'
                    
                  />                  
                </div>
              </div>
              }
            
              <div className="flex flex-row py-2  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Codigo QX
                  </label>
                  <input
                    type="text"                                       
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    name='codigoqx'
                  />                  
                </div>
                <div className="w-1/3  px-1 text-center ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Liqui?
                  </label>
                  <div className="topping">
                    <input
                        type="checkbox"                                    
                        checked={isCheckedLiqui}
                        onChange={handleOnChangeLiqui}
                        />
                </div>
                </div>
                <div className="w-1/3  px-1 text-center">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  No. Apli. %Base
                  </label>
                  <div className="topping">
                    <input
                        type="checkbox"                                    
                        checked={isCheckedBase}
                        onChange={handleOnChangeBase}
                        />
                </div>
                </div>
                
                
              </div>
            

            
          </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Aceptar
          </button>
        </div>
        </form>
        </div>
      </div>
    </div>   
    {loading &&
      <div className="relative flex items-center justify-center h-screen">
      <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
              <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg">Cargando</p>
          </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
  </div>} 
    {seleccionarHonorario? <ModalListaDeSeleccionHonorariosFormasLiquidacion setseleccionarHonorario={setseleccionarHonorario} passDataHonorarios={passDataHonorarios}/>:null}
    {modalOnFactor? <ModalFactorFormasDeLiquidacion setmodalOnFactor={setmodalOnFactor} passDataFactor={passDataFactor}/>:null}
    {modalOnMensajeHonorarios? <ModalInsertarHonorarioFormasLiquidacion setmodalOnMensajeHonorarios={setmodalOnMensajeHonorarios} mensajeHonorarioInsert={mensajeHonorarioInsert}/>:null}
  </div>
  )
}

export default ModalAgregarUnaFormaDeLiquidacionEnUpdate